import { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { ChakraProvider } from '@chakra-ui/react';

import initialTheme from 'theme/theme';

import ProtectedRoute from 'auth/ProtectedRoute';

import AuthLayout from 'layouts/auth';
import AdminLayout from 'layouts/admin';

export default function Main() {
  const [currentTheme, setCurrentTheme] = useState(initialTheme);

  return (
    <ChakraProvider theme={currentTheme}>
      <Routes>
        <Route path="auth/*" element={<AuthLayout />} />

        <Route
          path="/*"
          element={
            <ProtectedRoute
              element={<AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />}
            />
          }
        />

        <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
      </Routes>
    </ChakraProvider>
  );
}